//

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allow your team to quickly build robust real-time web applications.
 */

import './echo';
import { installCustomerAddressAutocomplete } from './customer-address-autocomplete';
import { mountDeliveryTracking } from './delivery-tracking';
import { installOperationalAccessibility } from './operational-accessibility';
import { installPosAllergenDialog } from './pos-allergen-dialog';
import {
    cashTenderSufficient,
    cashTenderSummary,
    createCashTender,
    parseCashCents,
    splitCashSufficient,
} from './pos-cash-tender';
import { createPosCategoryNavigation } from './pos-category-navigation';
import { createPosRealtimeGate } from './pos-realtime-gate';
import { openTicketPopup } from './pos-ticket-print';
import { installStripeCheckoutBootstrap } from './stripe-checkout-bootstrap';

window.createPosRealtimeGate = createPosRealtimeGate;
window.createPosCategoryNavigation = createPosCategoryNavigation;
window.openTicketPopup = openTicketPopup;
window.createCashTender = createCashTender;
window.cashTenderSufficient = cashTenderSufficient;
window.cashTenderSummary = cashTenderSummary;
window.splitCashSufficient = splitCashSufficient;
window.parseCashCents = parseCashCents;

const operationalAccessibility = installOperationalAccessibility();
const posAllergenDialog = installPosAllergenDialog();
const stripeCheckout = installStripeCheckoutBootstrap();
const addressAutocomplete = installCustomerAddressAutocomplete();
void stripeCheckout.mount();

if (import.meta.hot) {
    import.meta.hot.dispose(() => {
        operationalAccessibility.dispose();
        posAllergenDialog.dispose();
        stripeCheckout.dispose();
        addressAutocomplete.dispose();
    });
}

function maybeInitDeliveryTracking() {
    mountDeliveryTracking();
}

document.addEventListener('DOMContentLoaded', () => {
    maybeInitDeliveryTracking();

    const observer = new MutationObserver(maybeInitDeliveryTracking);
    observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener('livewire:navigated', maybeInitDeliveryTracking);
